import { call, cancel, fork, put, select, take, takeEvery } from 'redux-saga/effects'

import history from 'helpers/history';

import { onEvent } from 'helpers/saga';

import {
  CANCEL_INITIALIZE, cancelInitialize,
  INITIALIZE,
  SET_ACTIVE_ORDER,
  setActiveOrder,
  setActiveSpread,
  setInitializing,
  updateDimensions,
} from 'redux/reducers/app';
import { UPDATE_PROFILE } from 'redux/reducers/user';
import { getCurrentBookSpreads } from 'redux/selectors/books';

import { isAuthenticated } from 'redux/selectors/user';

import { getBooks } from 'redux/sagas/books';
import { createNewOrder, getOrders, getSingleOrder, setSpecialTexts } from 'redux/sagas/orders';
import { getDesign } from 'redux/sagas/design';

function* init({ bookId, orderId, createOrder }) {
  const authenticated = yield select(state => isAuthenticated(state));
  const hadOrderId = orderId;

  yield put(setActiveOrder(orderId));

  const books = yield call(getBooks);

  // If only 1 book available, pick the first
  if (books && books.count() === 1 && !bookId) {
    bookId = books.getIn([0, 'id']);
  }

  // Only get order when authenticated
  if (authenticated) {
    // Order id is set, request order
    if (orderId) {
      const order = yield call(getSingleOrder, { id: orderId });
      orderId = order ? orderId : null;
      bookId = order ? bookId : null;
    }

    // No order id found, get all
    if (!orderId && !createOrder) {
      const orders = yield call(getOrders);
      // Pick first when only single order is returned
      if (orders && orders.count() > 1) {
        orderId = orders.keySeq().first();
      }
    }
  }

  // Create book if requested
  if (createOrder) {
    const { book, name, birthday } = createOrder;

    orderId = yield call(createNewOrder, {
      book,
      name,
      birthday,
      onlyWhenEmpty: false,
      pushHistory: false,
    });
  }

  // Check if orderId is in state
  const order = yield select(state => state.getIn(['orders', orderId]));

  // Order isn't available (not an order of the user)
  if (!order) {
    orderId = null;

    // Set orderId of latest book
    const orders = yield select(state => state.get('orders'));
    if (orders && orders.count() > 0) {
      orderId = orders.keySeq().first();
    }
  }

  // If we finally have order, check if we need to get design and set it as active
  if (orderId) {
    // Get design in sync
    const designId = yield select(state => state.getIn(['orders', orderId, 'design']));
    yield call(getDesign, { designId });
    bookId = yield select(state => state.getIn(['orders', orderId, 'book']));
  }

  // Everything done and requested, now set active order
  yield put(setActiveOrder(orderId));

  if (orderId) {
    yield setSpecialTexts({ type: SET_ACTIVE_ORDER });
  }

  // Set active spread if it hasn't been set
  const firstSpread = yield select(state => getCurrentBookSpreads(state).getIn([0, 'id']));
  const activeSpread = yield select(state => state.getIn(['app', 'activeSpreadIds', orderId], firstSpread));
  yield put(setActiveSpread(activeSpread));

  // Initial loading of the app is done
  yield put(setInitializing(false));

  let location = `/`;
  if (bookId && orderId) {
    location = `/${bookId}/${orderId}`;
  }

  if (
    (hadOrderId && orderId !== hadOrderId) ||
    (location && history.location.pathname.substring(0, location.length) !== location)
  ) {
    history.replace(location);
  }

  // Start listening to profile update
  yield takeEvery(UPDATE_PROFILE, getOrders);
}

export function* dimensionUpdater() {
  const onResizeChannel = yield call(onEvent, window, 'resize', null, 50);

  while (true) {
    yield take(onResizeChannel);

    try {
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      yield put(updateDimensions(width, height));
    } catch (e) {
      pe(e, 'failed dimension update');
    }
  }
}

export default function* saga() {
  yield fork(dimensionUpdater);

  while (true) {
    const workerTask = yield takeEvery(INITIALIZE, init)
    yield take(CANCEL_INITIALIZE)
    yield cancel(workerTask)
  }
}



// WEBPACK FOOTER //
// ./app/redux/sagas/app.js